/*
 * Farida Gupta - "Read more" / "Read less" inline expand for a description (fg-collection-story.liquid).
 *
 * Deliberately independent of theme.js (plain custom element, no shared private state) - same
 * reasoning as fg-load-more.js: this only needs to react to its own click and its own resize.
 *
 * Overflow is measured, not assumed: `is-truncatable` is added only if the description's full
 * (scrollHeight) content is actually taller than its clamped (clientHeight) box, so a description
 * short enough to never clip never gets a "Read more" link with nothing to reveal.
 */
class FgReadMore extends HTMLElement {
  connectedCallback() {
    this.description = this.querySelector('.fg-collection-story__description');
    this.button = this.querySelector('.fg-collection-story__link');

    if (!this.description || !this.button) return;

    this.moreText = this.button.dataset.moreText || this.button.textContent.trim();
    this.lessText = this.button.dataset.lessText || this.moreText;

    this.button.addEventListener('click', () => this.toggle());

    this.onResize = () => {
      if (!this.classList.contains('is-expanded')) this.measure();
    };
    window.addEventListener('resize', this.onResize, { passive: true });

    requestAnimationFrame(() => this.measure());
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.onResize);
  }

  measure() {
    this.classList.add('is-truncatable');
    const isOverflowing = this.description.scrollHeight - this.description.clientHeight > 1;
    this.classList.toggle('is-truncatable', isOverflowing);
  }

  toggle() {
    const expanded = this.classList.toggle('is-expanded');
    this.button.setAttribute('aria-expanded', String(expanded));
    this.button.textContent = expanded ? this.lessText : this.moreText;
  }
}

if (!window.customElements.get('fg-read-more')) {
  window.customElements.define('fg-read-more', FgReadMore);
}
